import { IBatchImportResultDTO, IImportInvoiceResultDTO } from "../../libs/core-api-requests/dirs/globalImportInvoicesRequest";
import { IImportFilesFilterDTO, IImportFileViewDTO, IImportFilesBatchRequestDTO, ILoadAndGetImportedInvoiceByFileNameDTO, ILocalFileDTO } from "../../libs/coreapi-dto/dirs/globalImportInvoices";
import { IInvoiceImportedDTO } from "../../libs/coreapi-dto/documents/importedInvoice";
import { ICoreErrorMessage } from "../../libs/core-api-requests/common";
import CoreApiService from "../../system/api/coreApiService";
import renderGlobalAlert from "../../system/hooks/useGlobalAlert";

export class GlobalImportInvoicesDataProvider {
    private _coreApiService: CoreApiService;

    constructor(coreApiService: CoreApiService) {
        this._coreApiService = coreApiService;
    }

    getImportFilesView(filter: IImportFilesFilterDTO, callback: (entities: IImportFileViewDTO[], totalCount: number) => void) {
        this._coreApiService.globalImportInvoicesRequest
            .then(r => r.getImportFilesView(filter, (e) => {
                if (e.respType === "isCompleted") {
                    try {
                        callback(e.data.entities, e.data.totalCount);
                    } catch (error) {
                        console.error(error);
                        callback([], 0);
                    }
                } else {
                    const error = e?.message as ICoreErrorMessage | undefined;
                    console.error(error?.title ?? "GlobalImportInvoicesDataProvider getImportFilesView !isCompleted");
                    renderGlobalAlert({
                        variant: "error",
                        statusCode: error?.statusCode ?? 0,
                        title: "Ошибка загрузки файлов",
                        detail: error?.detail || error?.title || "Не удалось получить список файлов для импорта"
                    });
                    callback([], 0);
                }
            }))
            .catch(err => {
                console.error(err);
                renderGlobalAlert({
                    variant: "error",
                    statusCode: 0,
                    title: "Ошибка загрузки файлов",
                    detail: "Не удалось получить список файлов для импорта"
                });
                callback([], 0);
            });
    }

    loadAndGetByFileName(
        dto: ILoadAndGetImportedInvoiceByFileNameDTO,
        callback: (entity: IInvoiceImportedDTO | null, errorMessage?: ICoreErrorMessage | null) => void
    ) {
        this._coreApiService.globalImportInvoicesRequest
            .then(r => r.loadAndGetByFileName(dto, (e) => {
                if (e.respType === "isCompleted") {
                    try {
                        callback(e.data, null);
                    } catch (error) {
                        console.error(error);
                        callback(null, null);
                    }
                } else {
                    const error = e?.message as ICoreErrorMessage | undefined;
                    console.error(error?.title ?? "GlobalImportInvoicesDataProvider loadAndGetByFileName !isCompleted");
                    callback(null, error ?? null);
                }
            }));
    }

    importByFiles(request: IImportFilesBatchRequestDTO, callback: (result: IBatchImportResultDTO) => void) {
        this._coreApiService.globalImportInvoicesRequest
            .then(r => r.importByFiles(request, (e) => {
                if (e.respType === "isCompleted") {
                    try {
                        callback(e.data);
                    } catch (error) {
                        console.error(error);
                    }
                } else {
                    throw new Error(e?.message.title ?? "GlobalImportInvoicesDataProvider importByFiles !isCompleted");
                }
            }));
    }

    importAndCreate(request: IImportFilesBatchRequestDTO, callback: (result: IBatchImportResultDTO) => void, signal?: AbortSignal) {
        this._coreApiService.globalImportInvoicesRequest
            .then(r => r.importAndCreate(request, (e) => {
                if (e.respType === "isCompleted") {
                    try {
                        callback(e.data);
                    } catch (error) {
                        console.error(error);
                    }
                } else {
                    throw new Error(e?.message.title ?? "GlobalImportInvoicesDataProvider importAndCreate !isCompleted");
                }
            }, signal));
    }

    deleteFilesLocal(files: ILocalFileDTO[], callback: (success: boolean) => void) {
        this._coreApiService.globalImportInvoicesRequest
            .then(r => r.deleteFilesLocal(files, (e) => {
                if (e.respType === "isCompleted") {
                    try {
                        callback(e.data);
                    } catch (error) {
                        console.error(error);
                    }
                } else {
                    throw new Error(e?.message.title ?? "GlobalImportInvoicesDataProvider deleteFilesLocal !isCompleted");
                }
            }));
    }

    preview(file: ILocalFileDTO, callback: (result: IImportInvoiceResultDTO) => void) {
        this._coreApiService.globalImportInvoicesRequest
            .then(r => r.preview(file, (e) => {
                if (e.respType === "isCompleted") {
                    try {
                        callback(e.data);
                    } catch (error) {
                        console.error(error);
                    }
                } else {
                    throw new Error(e?.message.title ?? "GlobalImportInvoicesDataProvider preview !isCompleted");
                }
            }));
    }

    previewBatch(files: ILocalFileDTO[], callback: (result: IBatchImportResultDTO) => void) {
        this._coreApiService.globalImportInvoicesRequest
            .then(r => r.previewBatch(files, (e) => {
                if (e.respType === "isCompleted") {
                    try {
                        callback(e.data);
                    } catch (error) {
                        console.error(error);
                    }
                } else {
                    throw new Error(e?.message.title ?? "GlobalImportInvoicesDataProvider previewBatch !isCompleted");
                }
            }));
    }
}
